import PropTypes from "prop-types";

function InterpolationTooltipData({ interpolationDetails = {} }) {
    const returnComponent = () => {
        const { title, studyTypeTitle } = interpolationDetails?.studyTypeMethod || {};
        const textColor = studyTypeTitle === "Home Use Test" ? "#005eef" : "green";

        return (
            <div
                style={{
                    background: "#f3f3f3",
                    padding: "10px",
                }}
            >
                <div
                    style={{
                        margin: "0px 0px 10px 0px",
                        borderRadius: 5,
                        color: "black",
                        padding: "5px",
                    }}
                >
                    <div style={{ marginBottom: "15px" }}>
                        <span
                            style={{
                                color: "#005eef",
                                fontWeight: 700,
                                fontSize: "16px",
                            }}
                        >
                            Interpolation Details
                        </span>
                    </div>

                    <div style={{ marginBottom: "12px" }}>
                        <span style={{ fontWeight: 700 }}>Target Likert Scale : </span>
                        <span>{interpolationDetails?.likertScale || ""}</span>
                    </div>

                    <div style={{ marginBottom: "12px" }}>
                        <span style={{ fontWeight: 700 }}>Target Study Type Method : </span>
                        <span>{title || ""} </span>
                        <span style={{ color: textColor }}>({studyTypeTitle || ""})</span>
                    </div>

                    <div style={{ marginBottom: "12px" }}>
                        <span style={{ fontWeight: 700 }}>Interpolation Model : </span>
                        <span>Quantile Mapping</span>
                    </div>

                    <div style={{ marginBottom: "0px" }}>
                        <span style={{ fontWeight: 700 }}>Target Country : </span>
                        <span>{interpolationDetails?.country || ""}</span>
                    </div>
                </div>
            </div>
        );
    };

    return <div>{returnComponent()}</div>;
}

InterpolationTooltipData.propTypes = {
    interpolationDetails: PropTypes.array,
};

export default InterpolationTooltipData;
